module.exports = __webpack_public_path__ + "static/abhay-b7e66fd53f12304980954e3b1791adac.jpeg";